import React from "react";
import ModalFormImputa from "./ModalFormImputa";

const ModalImputa = ({ show, handleClose, imputa }) => {
  return (
    <ModalFormImputa show={show} handleClose={handleClose} imputa={imputa} />
  );
};

export default ModalImputa;
